module.exports = __webpack_public_path__ + "static/img/drugs.7bc0b75d.png";